<template>
    <footer id="footer" class="d-print-none">
        <div class="container">

            <div class="row justify-content-between">
                <div class="col-lg-auto">

                    <ul class="list-inline">
                        <li class="list-inline-item">
                            Zikibet S.r.l.
                        </li>
                        <li class="list-inline-item">
                            C.so Della Repubblica, 109 - 04100, Latina (IT)
                        </li>
                        <li class="list-inline-item">
                            P.I. 03055430593
                        </li>
                        <li class="list-inline-item">
                            &copy; 2026, Tutti i diritti riservati
                        </li>
                    </ul>

                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <a href="https://www.iubenda.com/privacy-policy/48429943" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a>
                        </li>
                        <li class="list-inline-item">
                            <router-link :to="{ name: 'public.infos' }">
                                Informazioni
                            </router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link :to="{ name: 'public.terms' }">
                                Termini di utilizzo
                            </router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link :to="{ name: 'public.privacy' }">
                                Privacy politicy
                            </router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link :to="{ name: 'public.truffe' }">
                                Evita la truffa
                            </router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link :to="{ name: 'public.contattaci' }">
                                Contattaci
                            </router-link>
                        </li>
                    </ul>

                </div>
                <div class="col-lg-auto">

                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <img src="/images/18.webp"/>
                        </li>
                        <li class="list-inline-item">
                            <img src="/images/adm.webp"/>
                        </li>
                    </ul>

                </div>
            </div>

        </div>
    </footer>
</template>

<script>
(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);

export default {
    name: "ComponentZikiFooter"
};
</script>

<style scoped>
#footer {
    margin-top: auto;
    width: 100%;
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    border-top: 2px solid #D3B100;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.5);
}

#footer .container {
    padding: 1.5rem 15px;
}

#footer ul {
    margin-bottom: 0.5rem;
}

#footer li,
#footer a {
    color: #e0e0e0;
    font-size: 0.875rem;
    transition: color 0.3s ease;
}

#footer a:hover {
    color: #FFD700;
    text-decoration: none;
}

#footer img {
    height: 40px;
    width: auto;
    opacity: 0.9;
    transition: opacity 0.3s ease;
}

#footer img:hover {
    opacity: 1;
}

@media (max-width: 768px) {
    #footer .container {
        padding: 1rem 15px;
    }
    
    #footer li,
    #footer a {
        font-size: 0.75rem;
    }
    
    #footer img {
        height: 30px;
    }
}
</style>
